export default "__VITE_ASSET__BrrL1QWe__"